/**
 * โรงคลัง (the warehouse): every town has one, with a keeper who opens the player's own store (the user,
 * 2026-10-10: one store shared by every town, opened only at a keeper). Rules: systems/warehouse.ts.
 * The buildings and keepers are already in the maps: the plains (data/layouts/plains.ts), town-b/c/d
 * (layouts/townGrey.ts) and the cities (layouts/cities.ts) all open onto the `plains-warehouse` room
 * (data/interiors.ts), whose keeper carries `keeperTitle`.
 */
export const WAREHOUSE = {
  /** Slots of a new store (one item kind per slot). */
  slots: 60,
  /** The most a store can ever grow to (expansion comes later). */
  maxSlots: 120,
  /** Copies of one plain (unrolled) item a slot holds; rolled items never stack. */
  stackMax: 99,
  /** Most ตำลึง the store keeps. */
  goldMax: 99_999_999,
  /** The keeper's title (an NPC with it, near enough, opens the store). */
  keeperTitle: 'ผู้ดูแลโรงคลัง',
  /** Metres from the keeper the store stays open; further away it closes. */
  reach: 2.5,
} as const;

/** Player-facing words (Thai). */
export const WAREHOUSE_TEXT = {
  name: 'โรงคลัง',
  bag: 'กระเป๋า',
  store: 'คลังฝากของ',
  deposit: 'ฝาก',
  depositAll: 'ฝากทั้งหมด',
  withdraw: 'รับคืน',
  split: 'แบ่ง',
  tidy: 'จัดรวมกอง',
  gold: 'ตำลึงในคลัง',
  goldIn: 'ฝากตำลึง',
  goldOut: 'ถอนตำลึง',
  far: 'อยู่ไกลผู้ดูแลโรงคลัง',
  full: 'คลังเต็ม',
  bagFull: 'กระเป๋าเต็ม',
  worn: 'ของที่สวมอยู่ฝากไม่ได้ ถอดก่อน',
  noGold: 'ตำลึงไม่พอ',
  hint: 'คลิกหรือลากข้ามฝั่ง ย้ายทั้งกอง · Shift+คลิก ทีละชิ้น · คลิกขวาที่กองในคลัง แบ่งครึ่ง',
} as const;
